var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-checkbox',{staticClass:"mine-ob",staticStyle:{"margin-right":"20px"},model:{value:(_vm.currentVal),callback:function ($$v) {_vm.currentVal=$$v},expression:"currentVal"}},[_vm._v("隐藏空文件夹")])}
var staticRenderFns = []

export { render, staticRenderFns }